import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Layout, Tooltip, Typography } from 'antd';
import { memo, useCallback, useContext, useState } from 'react';
import LogoMain from '../assets/logo_main.png';
import { AuthContext } from '../contexts/AuthContext';
import Setting from './kits/Setting';
import ShowQR from './kits/ShowQR';
import TwoFactorForm from './kits/TwoFactorForm';

const { Header } = Layout;
const { Text } = Typography;

const HeaderLayout = () => {
  const {
    authState: { user },
    logoutUser,
  } = useContext(AuthContext);
  const [openSetting, setOpenSetting] = useState(false);
  const [openModalShowQR, setOpenModalShowQR] = useState(false);
  const [openModalTwoFactor, setOpenModalTwoFactor] = useState(false);

  const logout = useCallback(() => {
    logoutUser();
  }, [logoutUser]);

  return (
    <Header
      className="site-layout-background"
      style={{
        padding: 0,
        top: 0,
        position: 'sticky',
        zIndex: 2,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <img
          src={LogoMain}
          alt="Yum Yum Chat"
          style={{
            width: '150px',
            // marginTop: '-30px',
          }}
        />
        <div style={{ marginRight: '20px' }}>
          <Tooltip title="Setting" placement="bottom">
            <Avatar
              icon={<UserOutlined />}
              src={user?.avatar}
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenSetting(true)}
            />
          </Tooltip>

          {openSetting && (
            <Setting
              openSetting={openSetting}
              setOpenSetting={setOpenSetting}
              handleOpenShowQR={() => {
                setOpenModalShowQR(true);
              }}
            />
          )}
          {openModalShowQR && (
            <ShowQR
              openModalShowQR={openModalShowQR}
              handleCancelModalShowQR={() => setOpenModalShowQR(false)}
              handleOpenTwoFactor={() => setOpenModalTwoFactor(true)}
            />
          )}
          {openModalTwoFactor && (
            <TwoFactorForm
              openModalTwoFactor={openModalTwoFactor}
              handleCancelModalTwoFactor={() => setOpenModalTwoFactor(false)}
            />
          )}
          <Text
            strong
            style={{ fontSize: '16px', margin: '0px 10px', color: '#fff' }}
          >
            Welcome, {user?.fullName}!
          </Text>
          <Button
            type="danger"
            shape="round"
            icon={<LogoutOutlined />}
            onClick={logout}
          >
            Logout
          </Button>
        </div>
      </div>
    </Header>
  );
};

export default memo(HeaderLayout);
